import React from 'react';
import { Button, Stack } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { ContactOrgLinkPayload, useOrganizationLink } from '../data/useOrganizationLink';
import { ContactOrgLinkControlUnbound } from './ContactOrgLinkControl';
import { SimpleDialog } from '../../primitives';
import { EditItemProps } from '../../../api/useNewItem';

export interface ContactOrgLinkDialogProps {
  data: EditItemProps<ContactOrgLinkPayload>;
  onDelete?: (item: ContactOrgLinkPayload) => void; // Optional delete handler
}

export const ContactOrgLinkDialog: React.FC<ContactOrgLinkDialogProps> = ({ 
  data,
  onDelete,
}) => {

  // 2. Hook enriches the state with async behaviors (fetching, creating)
  const hookData = useOrganizationLink(data.item || {}, x => data.update(x));

  const isEditing = !!data.item?._id;


  return (
    <SimpleDialog
      {...data.dialog}
      dialogTitle={isEditing ? "Редактировать связь" : "Привязать к компании"}
      save={() => data.save()}
      maxWidth="xs"
      noFullscreen
      submitOnModEnter
      simpleExtraActions={<>
        {!!onDelete &&
          <Button 
            color="error" 
            size="small" 
            startIcon={<DeleteOutline />} 
            onClick={() => onDelete && data.item && onDelete(data.item)}
          >
            Удалить связь
          </Button>}
      </>}
    >
      <Stack spacing={2} mt={1}>
        <ContactOrgLinkControlUnbound
          {...hookData}
          isOrganizationChangeDisabled={isEditing}
          onFieldChange={hookData.handleFieldChange}
          onOrgChange={hookData.handleOrgChange}
          onSearchChange={hookData.setSearchValue}
          value={data.item || {}}
        />

      </Stack>
    </SimpleDialog>
  );
};